<template>
  <v-container fluid>
    <v-card v-if="!editPage && !confirmPage" flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">{{
          wordList.lbl_delivery_list
        }}</v-card-title>
      <v-card-text>
        <v-card flat>
          <div
              v-if="isXs"
              class="d-flex justify-end br_b_1 br_t_1 py-2 mb-5"
          >
            <v-btn variant="text" color="black" class="px-1" @click="onClickListSearch">
              絞り込み検索<v-icon>mdi-text-search</v-icon>
            </v-btn>
            <v-btn variant="text" color="black" class="pl-3 pr-0" @click="onClickListSetting">
              設定<v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
            <v-menu open-on-hover location="bottom">
              <template #activator="{ props }">
                <v-btn variant="text" color="black" v-bind="props" class="pl-3 pr-0">
                  アクション
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </template>
              <v-list width="250" class="pl-5">
                <v-list-item
                    v-if="shipping_label_print_flg"
                    class="mb-3"
                    style="cursor: pointer"
                    @click="onClickTagPrintPreview"
                >
                  <v-icon class="mr-2 mb-1">mdi-application-edit-outline</v-icon
                  >荷札印刷
                </v-list-item>
                <v-list-item
                    v-if="delivery_order_print_flg"
                    class="mb-3"
                    style="cursor: pointer"
                    @click="onClickSlipPrintPreview"
                >
                  <v-icon class="mr-2 mb-1">mdi-file-document-edit</v-icon
                  >配達伝票印刷
                </v-list-item>
                <v-list-item
                    class="mb-3"
                    style="cursor: pointer"
                    @click="onClickDownload"
                >
                  <v-icon class="mr-2 mb-1">mdi-cloud-download</v-icon
                  >CSVダウンロード
                </v-list-item>
                <v-list-item
                    style="cursor: pointer"
                    @click="onClickCheckDelete"
                >
                  <v-icon class="mr-2">mdi-delete</v-icon>一括キャンセル
                </v-list-item>
              </v-list></v-menu
            >
          </div>

          <!-- 検索条件入力 { -->
          <v-expansion-panels v-else v-model="panel" flat multiple class="br_1">
            <v-expansion-panel>
              <v-expansion-panel-title
                  class="py-0 font-weight-bold bk_gray_3"
              >{{ wordList.lbl_search }}</v-expansion-panel-title
              >
              <v-expansion-panel-text class="bk_gray_3" eager>
                <v-divider/>
                <Form v-slot="{ meta }">
                  <v-card class="bk_gray_3" flat>
                    <v-card-text class="pt-9">
                      <v-row>
                        <!-- チェーンコード -->
                        <v-col
                            v-if="chainViewFlag"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                                                    <Field
                                                        v-slot="{ errors }"
                                                        v-model="chainSelectValues"
                                                        name="chainName"
                                                        :label="wordList.lbl_chain_name"
                                                        rules="max:100"
                                                    >
                            <div class="div-autocomplete-wrapper">
                              <div class="autocomplete-wrapper">
                                <v-autocomplete
                                    v-model="chainSelectValues"
                                    density="compact"
                                    :items="chainListItems ?? []"
                                    item-title="name"
                                    item-value="chain_code"
                                    :label="wordList.lbl_chain_name"
                                    :placeholder="wordList.plc_selectbox"
                                    :no-data-text="wordList.lbl_no_data_text"
                                    bg-color="white"
                                    :error-messages="errors"
                                    multiple
                                    return-object
                                    variant="outlined"
                                    @update:model-value="onChangeChain"
                                ></v-autocomplete>
                              </div>
                              <div class="select-all-wrapper">
                                <label
                                    class="select-all-checkbox-label"
                                    @click="onchangeChainAllCheck"
                                >
                                  <span class="select-all-checkmark">
                                    <div v-show="chainAllCheckFlag === 'some'">
                                      <i class="fas fa-minus" />
                                    </div>
                                    <div v-show="chainAllCheckFlag === 'all'">
                                      <i class="fas fa-check" />
                                    </div>
                                    <div v-show="chainAllCheckFlag === 'none'">
                                      <i
                                          class="fas"
                                          style="margin-right: 1px"
                                      />
                                    </div>
                                  </span>
                                  <span class="select-all-text">全選択</span>
                                </label>
                              </div>
                            </div>
                          </Field>
                        </v-col>
                        <!-- 店舗名 -->
                        <v-col
                            v-if="shopViewFlag === '1' || chainViewFlag === true"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                                                    <Field
                                                        v-slot="{ errors }"
                                                        v-model="shopSelectValues"
                                                        name="shopName"
                                                        :label="wordList.lbl_shop_name"
                                                        rules="max:100"
                                                    >
                            <div class="div-autocomplete-wrapper">
                              <div class="autocomplete-wrapper">
                                <v-autocomplete
                                    v-model="shopSelectValues"
                                    density="compact"
                                    :items="shopListItems ?? []"
                                    item-title="name"
                                    item-value="shop_code"
                                    :label="wordList.lbl_shop_name"
                                    :placeholder="wordList.plc_selectbox"
                                    :no-data-text="wordList.lbl_no_data_text"
                                    :error-messages="errors"
                                    multiple
                                    return-object
                                    variant="outlined"
                                    bg-color="#fff"
                                    :disabled="shopDisabledFlag"
                                    @update:model-value="onChangeShop"
                                ></v-autocomplete>
                              </div>
                              <div class="select-all-wrapper">
                                <label
                                    class="select-all-checkbox-label"
                                    @click="onchangeShopAllCheck"
                                >
                                  <span class="select-all-checkmark">
                                    <div v-show="shopAllCheckFlag === 'some'">
                                      <i class="fas fa-minus" />
                                    </div>
                                    <div v-show="shopAllCheckFlag === 'all'">
                                      <i class="fas fa-check" />
                                    </div>
                                    <div v-show="shopAllCheckFlag === 'none'">
                                      <i
                                          class="fas"
                                          style="margin-right: 1px"
                                      />
                                    </div>
                                  </span>
                                  <span class="select-all-text">全選択</span>
                                </label>
                              </div>
                            </div>
                          </Field>
                        </v-col>
                        <!-- 配達エリア -->
                        <v-col
                            v-if="shopViewFlag === '1' || chainViewFlag === true"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="areaSelectValues"
                              name="deliveryAreaName"
                              :label="wordList.lbl_delivery_area_name"
                              rules="max:100"
                          >
                            <v-autocomplete
                                v-model="areaSelectValues"
                                density="compact"
                                :items="areaListItems ?? []"
                                item-title="area_name"
                                item-value="area_code"
                                :label="wordList.lbl_delivery_area_name"
                                :placeholder="wordList.plc_selectbox"
                                :no-data-text="wordList.lbl_no_data_text"
                                :error-messages="errors"
                                return-object
                                variant="outlined"
                                bg-color="#fff"
                                :disabled="areaDisabledFlag"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                        <!-- 受付番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionReceptionNo"
                              name="receptionNumber"
                              :label="wordList.lbl_reception_number"
                              rules="numeric|max:10"
                          >
                            <v-text-field
                                v-model="searchConditionReceptionNo"
                                :label="wordList.lbl_reception_number"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 会員番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionMemberId"
                              name="memberId"
                              :label="wordList.lbl_member_id"
                              rules="max:100"
                          >
                            <v-text-field
                                v-model="searchConditionMemberId"
                                :label="wordList.lbl_member_id"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- お名前(漢字・かな) -->
                        <v-col
                            v-if="chainViewFlag === false"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionName"
                              name="nameKanjiKana"
                              :label="wordList.lbl_name_kanji_kana"
                              rules="max:100"
                          >
                            <v-text-field
                                v-model="searchConditionName"
                                :label="wordList.lbl_name_kanji_kana"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 電話番号 -->
                        <v-col
                            v-if="chainViewFlag === false"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionPhone"
                              name="tel"
                              :label="wordList.lbl_tel"
                              rules="max:100"
                          >
                            <v-text-field
                                v-model="searchConditionPhone"
                                :label="wordList.lbl_tel"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 郵便番号 -->
                        <v-col
                            v-if="chainViewFlag === false"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionZipCode"
                              name="zipcode"
                              :label="wordList.lbl_zipcode"
                              rules="max:100"
                          >
                            <v-text-field
                                v-model="searchConditionZipCode"
                                :label="wordList.lbl_zipcode"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 配達エリア -->
                        <v-col
                            v-if="shopViewFlag !== '1' && chainViewFlag === false"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="areaSelectValues"
                              name="deliveryAreaName"
                              :label="wordList.lbl_delivery_area_name"
                              rules="max:100"
                          >
                            <v-autocomplete
                                v-model="areaSelectValues"
                                density="compact"
                                :items="areaListItems ?? []"
                                item-title="area_name"
                                item-value="area_code"
                                :label="wordList.lbl_delivery_area_name"
                                :placeholder="wordList.plc_selectbox"
                                :no-data-text="wordList.lbl_no_data_text"
                                :error-messages="errors"
                                return-object
                                variant="outlined"
                                bg-color="#fff"
                                :disabled="areaDisabledFlag"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                            v-if="register_no_max_length > 0"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionRegisterNo"
                              name="レジNo"
                              rules="max:20"
                          >
                            <v-text-field
                                v-model="searchConditionRegisterNo"
                                label="レジNo"
                                density="compact"
                                variant="outlined"
                                bg-color="#fff"
                                :clearable="true"
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <v-col
                            v-if="receipt_no_max_length > 0"
                            cols="12"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <Field
                              v-slot="{ errors }"
                              v-model="searchConditionReceiptNo"
                              name="レシートNo"
                              rules="max:20"
                          >
                            <v-text-field
                                v-model="searchConditionReceiptNo"
                                label="レシートNo"
                                density="compact"
                                variant="outlined"
                                bg-color="#fff"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12" sm="4" class="py-0 pr-0">
                              <Field
                                  v-slot="{ errors }"
                                  v-model="searchConditionReceptionDateFromDisplay"
                                  name="recriptDateFrom"
                                  :label="wordList.lbl_recript_date_from"
                                  rules="max:100"
                              >
                                <v-menu
                                    v-model="ReceptionDateFrom"
                                    :close-on-content-click="false"
                                    location="bottom start"
                                    :offset="[0, -40]"
                                    transition="scale-transition"
                                >
                                  <template #activator="{ props }">
                                    <v-text-field
                                        v-bind="props"
                                        v-model="searchConditionReceptionDateFromDisplay"
                                        :label="wordList.lbl_recript_date_from"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                        clearable
                                        :error-messages="errors"
                                        bg-color="#fff"
                                        @click:clear="clearReceptionDateFrom"
                                    ></v-text-field>
                                  </template>
                                  <v-locale-provider
                                      locale="ja"
                                      :messages="{ ja: vuetifyJa }"
                                  >
                                    <v-date-picker
                                        v-datepicker-scroll
                                        v-model="searchConditionReceptionDateFrom"
                                        hide-header
                                        show-adjacent-months
                                        view-mode="month"
                                        @update:model-value="onReceptionDateFromSelected"
                                    ></v-date-picker>
                                  </v-locale-provider>
                                </v-menu>
                              </Field>
                            </v-col>
                            <p class="mt-3 mx-2">〜</p>
                            <v-col cols="12" sm="4" class="py-0 px-0">
                              <Field
                                  v-slot="{ errors }"
                                  v-model="searchConditionReceptionDateToDisplay"
                                  name="recriptDateTo"
                                  :label="wordList.lbl_recript_date_to"
                                  rules="max:100"
                              >
                                <v-menu
                                    v-model="ReceptionDateTo"
                                    :close-on-content-click="false"
                                    location="bottom start"
                                    :offset="[0, -40]"
                                    transition="scale-transition"
                                >
                                  <template #activator="{ props }">
                                    <v-text-field
                                        v-bind="props"
                                        v-model="searchConditionReceptionDateToDisplay"
                                        :label="wordList.lbl_recript_date_to"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                        clearable
                                        :error-messages="errors"
                                        bg-color="#fff"
                                        @click:clear="clearReceptionDateTo"
                                    ></v-text-field>
                                  </template>
                                  <v-locale-provider
                                      locale="ja"
                                      :messages="{ ja: vuetifyJa }"
                                  >
                                    <v-date-picker
                                        v-datepicker-scroll
                                        v-model="searchConditionReceptionDateTo"
                                        hide-header
                                        show-adjacent-months
                                        view-mode="month"
                                        @update:model-value="onReceptionDateToSelected"
                                    ></v-date-picker>
                                  </v-locale-provider>
                                </v-menu>
                              </Field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12" sm="4" class="py-0 pr-0">
                              <Field
                                  v-slot="{ errors }"
                                  v-model="searchConditionDeliveryDateFromDisplay"
                                  name="deliveryDateFrom"
                                  :label="wordList.lbl_delivery_date_from"
                                  rules="max:100"
                              >
                                <v-menu
                                    v-model="DeliveryDateFrom"
                                    :close-on-content-click="false"
                                    location="bottom start"
                                    :offset="[0, -40]"
                                    transition="scale-transition"
                                >
                                  <template #activator="{ props }">
                                    <v-text-field
                                        v-bind="props"
                                        v-model="searchConditionDeliveryDateFromDisplay"
                                        :label="wordList.lbl_delivery_date_from"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                        clearable
                                        :error-messages="errors"
                                        bg-color="#fff"
                                        @click:clear="clearDeliveryDateFrom"
                                    ></v-text-field>
                                  </template>
                                  <v-locale-provider
                                      locale="ja"
                                      :messages="{ ja: vuetifyJa }"
                                  >
                                    <v-date-picker
                                        v-datepicker-scroll
                                        v-model="searchConditionDeliveryDateFrom"
                                        hide-header
                                        show-adjacent-months
                                        view-mode="month"
                                        @update:model-value="onDeliveryDateFromSelected"
                                    ></v-date-picker>
                                  </v-locale-provider>
                                </v-menu>
                              </Field>
                            </v-col>
                            <p class="mt-3 mx-2">〜</p>
                            <v-col cols="12" sm="4" class="py-0 px-0">
                              <Field
                                  v-slot="{ errors }"
                                  v-model="searchConditionDeliveryDateToDisplay"
                                  name="deliveryDateTo"
                                  :label="wordList.lbl_delivery_date_to"
                                  rules="max:100"
                              >
                                <v-menu
                                    v-model="DeliveryDateTo"
                                    :close-on-content-click="false"
                                    location="bottom start"
                                    :offset="[0, -40]"
                                    transition="scale-transition"
                                >
                                  <template #activator="{ props }">
                                    <v-text-field
                                        v-bind="props"
                                        v-model="searchConditionDeliveryDateToDisplay"
                                        :label="wordList.lbl_delivery_date_to"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                        clearable
                                        :error-messages="errors"
                                        bg-color="#fff"
                                        @click:clear="clearDeliveryDateTo"
                                    ></v-text-field>
                                  </template>
                                  <v-locale-provider
                                      locale="ja"
                                      :messages="{ ja: vuetifyJa }"
                                  >
                                    <v-date-picker
                                        v-datepicker-scroll
                                        v-model="searchConditionDeliveryDateTo"
                                        hide-header
                                        show-adjacent-months
                                        view-mode="month"
                                        @update:model-value="onDeliveryDateToSelected"
                                    ></v-date-picker>
                                  </v-locale-provider>
                                </v-menu>
                              </Field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-0">
                          <v-card class="bk_gray_3" flat>
                            <v-card-title class="px-0 py-0 text-subtitle-2">
                              {{ wordList.lbl_status }}
                            </v-card-title>
                            <v-card-text class="px-0 py-0">
                              <v-row>
                                <div
                                    v-for="item in deliveryStatusName"
                                    :key="item.id"
                                    class="pr-3 pl-2 d-flex"
                                >
                                  <v-checkbox
                                      v-model="statusSelectedItem"
                                      :value="item.id"
                                      :label="item.name"
                                  ></v-checkbox>
                                </div>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mt-6"
                          :disabled="!meta.valid"
                          @click="onClickSearch"
                      ><v-icon>mdi-magnify</v-icon
                      >{{ wordList.lbl_search }}</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </Form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- 検索条件入力 } -->
          <!-- 一覧表示  { -->
          <v-card flat width="100%">
            <v-data-table-server
                v-model="selectListCheckbox"
                v-model:options="listOptions"
                item-key="receptionNo"
                :items="listDataArray"
                :items-length="listDataTotalCount"
                :loading="listLoading"
                :items-per-page="listOptions.itemsPerPage"
                :no-data-text="wordList.lbl_no_data_text"
                hide-default-footer
                show-select
                return-object
                :headers="mobileFilteredTableHeaders()"
                :row-props="() => ({ class: 'bk_gray_1' })"
                :mobile="isXs"
                :hide-default-header="isXs"
            >
              <template #top>
                <v-row>
                  <v-col
                      cols="12"
                      class="d-flex justify-space-between mt-9 mb-5"
                  >
                    <div class="d-flex align-center flex-wrap">
                      <span class="pl-3">全 {{ listDataTotalCount }} 件 </span
                      ><span class="pl-1"> {{ displayPagingRangeText }} </span>
                      <v-pagination
                          v-model="listOptions.page"
                          :length="pageCount"
                          :total-visible="7"
                          variant="elevated"
                          density="comfortable"
                      >
                      </v-pagination>
                    </div>
                    <div v-if="!isXs">
                      <v-btn
                          variant="text"
                          color="black"
                          class="px-2"
                          @click="onClickListSetting"
                      >
                        設定<v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                      <v-menu open-on-hover location="bottom">
                        <template #activator="{ props }">
                          <v-btn
                              variant="text"
                              color="black"
                              v-bind="props"
                              class="pr-0 pl-2"
                          >
                            アクション
                            <v-icon>mdi-cog</v-icon>
                          </v-btn>
                        </template>
                        <v-list width="250" class="pl-5">
                          <v-list-item
                              v-if="shipping_label_print_flg"
                              class="mb-3"
                              style="cursor: pointer"
                              @click="onClickTagPrintPreview"
                          >
                            <v-icon class="mr-2 mb-1"
                            >mdi-application-edit-outline</v-icon
                            >荷札印刷
                          </v-list-item>
                          <v-list-item
                              v-if="delivery_order_print_flg"
                              class="mb-3"
                              style="cursor: pointer"
                              @click="onClickSlipPrintPreview"
                          >
                            <v-icon class="mr-2 mb-1"
                            >mdi-file-document-outline</v-icon
                            >配達伝票印刷
                          </v-list-item>
                          <v-list-item
                              class="mb-3"
                              style="cursor: pointer"
                              @click="onClickDownload"
                          >
                            <v-icon class="mr-2 mb-1">mdi-cloud-download</v-icon
                            >CSVダウンロード
                          </v-list-item>
                          <v-list-item
                              style="cursor: pointer"
                              @click="onClickCheckDelete"
                          >
                            <v-icon class="mr-2">mdi-delete</v-icon
                            >{{ wordList.btn_delete_all }}
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <!-- モバイル時のみ全選択チェックボックスを表示（hide-default-headerでデフォルトヘッダーを非表示にしているため） -->
              <template #thead="{ selectAll, allSelected, someSelected }">
                <tr v-if="isXs">
                  <th>
                    <v-checkbox-btn
                        :model-value="allSelected"
                        :indeterminate="someSelected && !allSelected"
                        @update:model-value="selectAll"
                    />
                  </th>
                </tr>
              </template>
              <template
                  #[`item.data-table-select`]="{ item, internalItem, isSelected, toggleSelect }"
              >
                <v-checkbox-btn
                    v-if="item.cancelAllowed"
                    :model-value="item.cancelAllowed ? isSelected(internalItem) : false"
                    @update:model-value="toggleSelect(internalItem)"
                >
                </v-checkbox-btn>
              </template>
              <!-- PC表示: 詳細ボタン -->
              <template #[`item.detail`]="{ item }">
                <div>
                  <v-btn
                      variant="outlined"
                      color="primary"
                      class="my-2 ml-2"
                      size="x-small"
                      rounded="xl"
                      icon
                      @click="onClickEditOrView(item)"
                  >
                    <v-icon v-if="shouldEdit(item)">mdi-pencil</v-icon>
                    <v-icon v-else>mdi-information</v-icon>
                  </v-btn>
                </div>
              </template>
              <!-- PC表示: キャンセルボタン -->
              <template #[`item.cancel`]="{ item }">
                <div>
                  <v-btn
                      :disabled="item.cancelAllowed === false"
                      variant="outlined"
                      color="red"
                      class="my-2 ml-2 mr-0"
                      size="x-small"
                      rounded="xl"
                      icon
                      @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </div>
              </template>
              <!-- モバイル表示: 配達完了時刻の下に編集/確認・キャンセルボタン（横並び・右寄せ） -->
              <template v-if="isXs" #[`item.mobileActions`]="{ item }">
                <div class="d-flex justify-end">
                  <v-btn
                      variant="outlined"
                      color="primary"
                      class="my-2 mx-2"
                      @click="onClickEditOrView(item)"
                  >
                    <v-icon v-if="shouldEdit(item)">mdi-pencil</v-icon>
                    <v-icon v-else>mdi-information</v-icon>
                    <span v-if="shouldEdit(item)">編集</span>
                    <span v-else>確認</span>
                  </v-btn>

                  <v-btn
                      :disabled="item.cancelAllowed === false"
                      variant="outlined"
                      color="red"
                      class="my-2 ml-2 mr-0"
                      @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-cancel</v-icon>
                    キャンセル
                  </v-btn>
                </div>
              </template>
            </v-data-table-server>
          </v-card>
        </v-card>
      </v-card-text>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- 配達依頼編集画面 { -->
    <v-card v-if="editPage && !confirmPage && editDeliveryRequest" flat>
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_delivery_edit }}
      </v-card-title>
      <Form ref="editFormRef" v-slot="{ meta }">
        <v-card-text>
          <v-card flat>
            <v-card-text>
              <!-- 受付番号 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_reception_no }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                    cols="12"
                    sm="7"
                    md="7"
                    lg="7"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.reception_no"
                      name="receptionNo"
                      :label="wordList.lbl_reception_no"
                      rules="required"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.reception_no"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達先住所 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                  >{{ wordList.lbl_delivery_destination_address }}
                    <ImportantChip></ImportantChip
                    ></v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="color_black">
                  <!-- 個人情報閲覧可 または 配送住所1表示フラグが1の場合、住所1を表示 -->
                  <template
                      v-if="
                        isPersonalInfoPossible === true ||
                        is_delivery_address1_display === 1
                      "
                  >
                    <!-- 個人情報非表示時は郵便番号を分割表示しない -->
                    <template v-if="isPersonalInfoPossible === true">
                      {{ editDeliveryRequest?.delivery_zip_code ? "〒" : "" }}
                      {{ editDeliveryRequest?.delivery_zip_code?.substring(0, 3) }}
                      {{ editDeliveryRequest?.delivery_zip_code ? "-" : "" }}
                      {{ editDeliveryRequest?.delivery_zip_code?.substring(3) }}
                    </template>
                    {{ editDeliveryRequest?.delivery_address1 }}
                  </template>
                  <template v-else>
                    {{ editDeliveryRequest?.delivery_address1 }}
                  </template>
                </v-col>
              </v-row>
              <!-- 住所変更ボタン -->
              <v-row class="mt-0">
                <v-col cols="12" sm="4" md="4" lg="4"></v-col>
                <v-col class="pl-2 pt-0"
                  ><v-btn
                    size="small"
                    color="primary"
                    variant="outlined"
                    :disabled="isDisabled"
                    @click="onClickAddressUpdate"
                >
                  {{ wordList.btn_address_change }}
                </v-btn>
                </v-col>
              </v-row>
              <!-- 配達先住所(番地) -->
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_destination_address_detail }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="12" sm="6" md="6" lg="6">
                  <Field
                      v-model="editDeliveryRequest.delivery_address2"
                      v-slot="{ errors }"
                      name="deliveryDestinationAddressDetail"
                      :label="wordList.lbl_delivery_destination_address_detail"
                      rules="required|max:100"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_address2"
                        :placeholder="
                        wordList.plc_delivery_destination_address_detail
                      "
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="12"
                    sm="7"
                    md="7"
                    lg="7"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_address2"
                      name="deliveryDestinationAddressDetail"
                      :label="wordList.lbl_delivery_destination_address_detail"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_address2"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 建物名 部屋番号 -->
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_room_num }}
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="12" sm="6" md="6" lg="6">
                  <Field
                      v-model="editDeliveryRequest.delivery_address3"
                      v-slot="{ errors }"
                      name="roomNum"
                  :label="wordList.lbl_room_num"
                      rules="max:100"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_address3"
                        :placeholder="wordList.plc_room_num"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="12"
                    sm="6"
                    md="6"
                    lg="6"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_address3"
                      name="roomNum"
                      :label="wordList.lbl_room_num"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_address3"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達希望エリア -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_area }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                    cols="12"
                    sm="7"
                    md="7"
                    lg="7"
                    class="text-body-1 color_black"
                >
                  <v-row
                      v-if="
                      listDeliveryArea == null || listDeliveryArea.length <= 1
                    "
                      dense
                  >
                    <Field
                        v-model="deliveryAreaName"
                        name="deliveryArea"
                        :label="wordList.lbl_delivery_area"
                        rules="required"
                    >
                      <v-text-field
                          v-model="deliveryAreaName"
                          density="compact"
                          variant="plain"
                          readonly
                      >
                      </v-text-field>
                    </Field>
                  </v-row>
                  <v-row
                      v-if="
                      listDeliveryArea !== null && listDeliveryArea.length > 1
                    "
                      dense
                  >
                    <v-btn
                        v-for="value in listDeliveryArea"
                        :key="value.area_code"
                        class="my-2 mx-2"
                        :class="{
                        btn_select_del_active:
                          value.area_code === editDeliveryRequest?.area_code,
                      }"
                        color="primary"
                        variant="outlined"
                        min-width="200"
                        @click="onClickListDeliveryArea(value)"
                    >
                      {{ value.area_name }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <!--配達希望時間選択 -->
              <v-row dense :class="{ mb_5: isDisabled }">
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_time_select }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                    cols="12"
                    sm="8"
                    md="8"
                    lg="8"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="displayDeliveryTime"
                      name="deliveryTimeSelect"
                      :label="wordList.lbl_delivery_time_select"
                      rules="required"
                  >
                    <v-text-field
                        v-model="displayDeliveryTime"
                        density="compact"
                        variant="plain"
                        readonly
                        hide-details
                    >
                    </v-text-field>
                  </Field>

                  <v-card
                      v-if="
                      disp_deliveryAvailabilityData.length > 0 && !isDisabled
                    "
                      class="mt-2 mb-8 px-3 py-3"
                      border
                      flat
                  >
                    <div id="wrap">
                      <div class="d-flex overflow-x-auto">
                        <div>
                          <div class="list_item_select_blank"></div>
                          <ul class="list_area br_b_1">
                            <li
                                v-for="[
                                delivery_id_desc,
                              ] in deliveryAvailabilityHeader"
                                :key="delivery_id_desc"
                                class="list_item_select_time"
                            >
                              {{ delivery_id_desc }}
                            </li>
                          </ul>
                        </div>
                        <div class="d-flex overflow-scrollr br_b_1">
                          <div
                              v-for="(
                              cols, deliverySelectDay
                            ) in disp_deliveryAvailabilityData"
                              :key="cols.delivery_data"
                          >
                            <ul
                                v-for="(delivery_data, deliverySelect) in cols"
                                :key="
                                delivery_data.delivery_date + delivery_data.key
                              "
                                class="list_area list_area_item"
                            >
                              <li
                                  v-if="delivery_data.key == 1"
                                  class="list_item_select list_item_day"
                              >
                                <div>
                                  <p class="mb-0">
                                    {{
                                      formatDate(delivery_data.delivery_date)
                                    }}
                                  </p>
                                </div>
                              </li>
                              <li class="list_item_select list_item_btn">
                                <a
                                    v-if="
                                    (delivery_data.availability !== '×' &&
                                      delivery_data.availability !== '0' &&
                                      delivery_data.availability !== '休') ||
                                    (delivery_data.already_requested === 1 &&
                                      editDeliveryRequest?.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest?.required_delivery_date ==
                                        delivery_data.delivery_date)
                                  "
                                    class="btn_select_del"
                                    :class="{
                                    btn_select_del_active:
                                      editDeliveryRequest?.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest?.required_delivery_date ==
                                        delivery_data.delivery_date,
                                  }"
                                    @click="
                                    onDeliveryAvailabilityClick(
                                      delivery_data.delivery_date,
                                      delivery_data.delivery_id,
                                      delivery_data.delivery_start_time,
                                      delivery_data.delivery_end_time,
                                      deliverySelectDay,
                                      deliverySelect
                                    )
                                  "
                                >
                                  <!--<i :class="getClass(delivery_data.availability)"></i>-->
                                  <i
                                      v-if="delivery_data.availability == '○'"
                                      class="circle_receive"
                                      :class="{
                                      circle_receive_active:
                                        deliverySelectDay ===
                                          deliverySelectDayBox &&
                                        deliverySelect === deliverySelectBox,
                                    }"
                                  ></i>
                                  <i
                                      v-else-if="
                                      delivery_data.availability == '△' ||
                                      delivery_data.availability == '▲'
                                    "
                                      class="triangle_receive"
                                      :class="{
                                      triangle_receive_active:
                                        deliverySelectDay ===
                                          deliverySelectDayBox &&
                                        deliverySelect === deliverySelectBox,
                                    }"
                                  ></i>
                                  <div
                                      v-else
                                      class="text_16px font-weight-bold color_primary"
                                  >
                                    {{ delivery_data.availability }}
                                  </div>
                                </a>
                                <div
                                    v-else-if="
                                    (delivery_data.availability === '×' ||
                                      delivery_data.availability === '0') &&
                                    !(
                                      editDeliveryRequest?.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest?.required_delivery_date ==
                                        delivery_data.delivery_date
                                    )
                                  "
                                >
                                  <i class="batsu_receive"></i>
                                </div>
                                <div
                                    v-else-if="
                                    delivery_data.availability === '休' &&
                                    !(
                                      editDeliveryRequest?.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest?.required_delivery_date ==
                                        delivery_data.delivery_date
                                    )
                                  "
                                    class="text_16px font-weight-bold color_primary"
                                >
                                  {{ delivery_data.availability }}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <p v-if="deliveryId_0_Flg" class="pt-0 mt-0">
                    ※配達開始時間
                    {{ deliveryStartTime }}～(当日配達)受付終了時間
                    {{ acceptableEndTime.substring(0, 5) }}まで
                  </p>
                </v-col>
              </v-row>
              <!-- 配達希望時間 -->
              <v-row v-if="deliveryId_0_Flg && !isDisabled && !is_hide_delivery_time_on_spot" dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_delivery_time }}
                  </v-row>
                </v-col>
                <v-col cols="1" sm="1" md="1" lg="1">
                  <Field
                      v-model="deliveryStartHourValues"
                      v-slot="{ errors }"
                      name="deliveryStartHour"
                  >
                    <v-autocomplete
                        v-model="deliveryStartHourValues"
                        density="compact"
                        :items="deliveryStartHourItem"
                        item-title="deliveryStartHour"
                        item-value="deliveryStartHour"
                        :error-messages="errors"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="onChangeDeliveryStartHour"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <p class="mt-3 mx-2 center text-body-1 text-black">時</p>
                <v-col cols="1" sm="1" md="1" lg="1">
                  <Field
                      v-model="deliveryStartMinitValues"
                      v-slot="{ errors }"
                      name="deliveryStartMinit"
                  >
                    <v-autocomplete
                        v-model="deliveryStartMinitValues"
                        density="compact"
                        :items="deliveryStartMinitItem"
                        item-title="label"
                        item-value="deliveryStartMinit"
                        :error-messages="errors"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="onChangeDeliveryStartMinit"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <p class="mt-3 mx-2 center text-body-1 text-black">
                  分から3時間以内
                </p>
              </v-row>
              <!-- お名前(漢字)-->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kanji }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && !isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                >
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.delivery_name1"
                      name="delivery_name1"
                      :label="wordList.lbl_name_kanji + '（姓）'"
                      rules="required|max:100"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name1"
                        :placeholder="wordList.plc_family_name_kanji"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_name1"
                      name="delivery_name1"
                      :label="wordList.lbl_name_kanji + '（姓）'"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name1"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && !isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                >
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.delivery_name2"
                      name="delivery_name2"
                      :label="wordList.lbl_name_kanji + '（名）'"
                      rules="required|max:100"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name2"
                        :placeholder="wordList.plc_first_name_kanji"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_name2"
                      name="delivery_name2"
                      :label="wordList.lbl_name_kanji + '（名）'"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name2"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="!isPersonalInfoPossible"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                    class="color_black mb-8"
                >
                  {{ personalInfoImpossible }}
                </v-col>
              </v-row>
              <!-- お名前(かな) -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kana }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && !isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                >
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.delivery_name_kana1"
                      name="delivery_name_kana1"
                      :label="wordList.lbl_name_kana + '（姓）'"
                      rules="required|max:100|regex:^[ぁ-んー]+$"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name_kana1"
                        :placeholder="wordList.plc_family_name_kana"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_name_kana1"
                      name="delivery_name_kana1"
                      :label="wordList.lbl_name_kana + '（姓）'"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name_kana1"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && !isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.delivery_name_kana2"
                      name="delivery_name_kana2"
                      :label="wordList.lbl_name_kana + '（名）'"
                      rules="required|max:100|regex:^[ぁ-んー]+$"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name_kana2"
                        :placeholder="wordList.plc_first_name_kana"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="isPersonalInfoPossible && isDisabled"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_name_kana2"
                      name="delivery_name_kana2"
                      :label="wordList.lbl_name_kana + '（名）'"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_name_kana2"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-if="!isPersonalInfoPossible"
                    cols="6"
                    sm="3"
                    md="3"
                    lg="3"
                    class="color_black mb-8"
                >
                  {{ personalInfoImpossible }}
                </v-col>
              </v-row>
              <!-- 電話番号 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_tel }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="12" sm="3" md="3" lg="3">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.delivery_phone"
                      name="tel"
                              :label="wordList.lbl_tel"
                      rules="required|numeric|min:10|max:11"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_phone"
                        :placeholder="wordList.plc_tel"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="12"
                    sm="3"
                    md="3"
                    lg="3"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_phone"
                      name="tel"
                              :label="wordList.lbl_tel">
                    <v-text-field
                        v-model="editDeliveryRequest.delivery_phone"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 決済方法 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_pay_method }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="6" sm="4" md="4" lg="4">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.payment_method"
                      name="payMethod"
                  :label="wordList.lbl_pay_method"
                      rules="required"
                  >
                    <v-autocomplete
                        v-model="editDeliveryRequest.payment_method"
                        density="compact"
                        :items="paymentMethodItems"
                        :placeholder="wordList.plc_selectbox"
                        :no-data-text="wordList.lbl_no_data_text"
                        variant="outlined"
                        return-object
                        :error-messages="errors"
                        :disabled="isDisabled || paymentMethodItems.length == 1"
                        @update:model-value="
                        onChangePaymentMethod(
                          editDeliveryRequest.payment_method
                        )
                      "
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col v-else cols="6" sm="4" md="4" lg="4">
                  <Field
                      v-model="editDeliveryRequest.payment_method"
                      name="payMethod"
                      :label="wordList.lbl_pay_method"
                  >
                    <v-autocomplete
                        v-model="editDeliveryRequest.payment_method"
                        density="compact"
                        :items="paymentMethodItems"
                        class="border-none"
                        variant="outlined"
                        disabled
                        :appearance="none"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 支払金額 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center"
                      v-if="paymentRequiredFlg"
                      dense
                        class="form-label-row mr-3 justify-sm-end"
                  >{{ wordList.lbl_pay_money }} <ImportantChip></ImportantChip
                  ></v-row>
                  <v-row align="center"
                      v-if="!paymentRequiredFlg"
                      dense
                        class="form-label-row mr-15 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                  </v-row>
                </v-col>
                <v-col cols="10" sm="4" md="4" lg="4">
                  <Field
                      v-if="paymentRequiredFlg"
                      v-slot="{ errors }"
                      v-model="dummy_payment_amount"
                      name="payMoney"
                      :label="wordList.lbl_pay_money"
                      rules="required|max:9"
                  >
                    <v-text-field
                        v-model="dummy_payment_amount"
                        class="text-right"
                        :placeholder="wordList.plc_pay_money"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        @focus="onFocus(dummy_payment_amount)"
                        @blur="onBlur(dummy_payment_amount)"
                    >
                    </v-text-field>
                  </Field>
                  <Field
                      v-if="!paymentRequiredFlg"
                      v-slot="{ errors }"
                      v-model="dummy_payment_amount"
                      name="payMoney"
                      :label="wordList.lbl_pay_money"
                      rules="max:9"
                  >
                    <v-text-field
                        v-model="dummy_payment_amount"
                        class="text-right"
                        :placeholder="wordList.plc_pay_money"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        @focus="onFocus(dummy_payment_amount)"
                        @blur="onBlur(dummy_payment_amount)"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
                <span class="mt-3">{{ wordList.lbl_yen }}</span>
              </v-row>
              <v-row v-if="setRegisterNoDisplay()" dense>
                <!-- レジNo -->
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                      wordList.lbl_cash_register_no
                    }}</v-row>
                </v-col>
                <v-col cols="2">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.register_no"
                      name="cashRegisterNo"
                      :label="wordList.lbl_cash_register_no"
                      :rules="register_no_validation"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.register_no"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row v-if="setReceiptNoDisplay()" dense>
                <!-- レシートNo -->
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                      wordList.lbl_receipt_no
                    }}</v-row>
                </v-col>
                <v-col cols="2">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.receipt_no"
                      name="receiptNo"
                      :label="wordList.lbl_receipt_no"
                      :rules="receipt_no_validation"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.receipt_no"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 個口数 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_unit_number }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="5" sm="4" md="4" lg="4">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.unit"
                      name="unitNumber"
                  :label="wordList.lbl_unit_number"
                      rules="required|min:1"
                  >
                    <v-autocomplete
                        v-model="editDeliveryRequest.unit"
                        :items="unitItems"
                        :no-data-text="wordList.lbl_no_data_text"
                        density="compact"
                        variant="outlined"
                        return-object
                        :disabled="isDisabled"
                        :error-messages="errors"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="5"
                    sm="4"
                    md="4"
                    lg="4"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.unit"
                      name="unitNumber"
                      :label="wordList.lbl_unit_number"
                  >
                    <v-autocomplete
                        v-model="editDeliveryRequest.unit"
                        class="border-none"
                        :items="unitItems"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- ハウスカード番号 -->
              <v-row v-if="house_card_display == 1" dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center"
                      v-if="house_card_required == 1"
                      dense
                        class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_house_card }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_house_card }}
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="5" sm="4" md="4" lg="4">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.house_card"
                      name="houseCard"
                  :label="wordList.lbl_house_card"
                      :rules="house_card_validation"
                  >
                    <v-text-field
                        v-if="house_card_required == 1"
                        v-model="editDeliveryRequest.house_card"
                        :placeholder="wordList.plc_house_card"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :hint="wordList.lbl_house_card_hint"
                        persistent-hint
                        @change="onChangeHouseCard()"
                    ></v-text-field>
                    <v-text-field
                        v-else
                        v-model="editDeliveryRequest.house_card"
                        :placeholder="wordList.plc_house_card"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        persistent-hint
                        @change="onChangeHouseCard()"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="5"
                    sm="4"
                    md="4"
                    lg="4"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.house_card"
                      name="houseCard"
                      :label="wordList.lbl_house_card"
                  >
                    <v-text-field
                        v-model="editDeliveryRequest.house_card"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 会員備考 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_memo_member }}
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="12" sm="7" md="7" lg="7">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.member_notes"
                      name="memoMember"
                  :label="wordList.lbl_memo_member">
                    <v-textarea
                        v-model="editDeliveryRequest.member_notes"
                        :placeholder="wordList.plc_memo_member"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="12"
                    sm="7"
                    md="7"
                    lg="7"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.member_notes"
                      name="memoMember"
                      :label="wordList.lbl_memo_member"
                  >
                    <v-textarea
                        v-model="editDeliveryRequest.member_notes"
                        class="border-none"
                        variant="outlined"
                        disabled
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達備考 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_memo_delivery }}
                  </v-row>
                </v-col>
                <v-col v-if="!isDisabled" cols="12" sm="7" md="7" lg="7">
                  <Field
                      v-slot="{ errors }"
                      v-model="editDeliveryRequest.delivery_notes"
                      name="memoDelivery"
                  :label="wordList.lbl_memo_delivery">
                    <v-textarea
                        v-model="editDeliveryRequest.delivery_notes"
                        :placeholder="wordList.plc_memo_delivery"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
                <v-col
                    v-else
                    cols="12"
                    sm="7"
                    md="7"
                    lg="7"
                    class="text-body-1 color_black"
                >
                  <Field
                      v-model="editDeliveryRequest.delivery_notes"
                      name="memoDelivery"
                      :label="wordList.lbl_memo_delivery"
                  >
                    <v-textarea
                        v-model="editDeliveryRequest.delivery_notes"
                        class="border-none"
                        density="compact"
                        variant="outlined"
                        disabled
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center flex-wrap">
              <!-- 戻るボタン -->
              <v-btn
                  variant="flat"
                  color="return"
                  class="btn_width_1 my-2 mx-2"
                  @click="onClickUpdateCancel"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}
              </v-btn>
              <!-- 登録手続きへボタン -->
              <v-btn
                  variant="flat"
                  color="primary"
                  class="btn_width_1 my-2 mx-2"
                  :disabled="!meta.valid"
                  @click="onClickUpdate"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                {{ wordList.btn_regist_confirm }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </Form>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 配達依頼編集画面 -->
    <!-- 配達依頼更新確認 { -->
    <v-card v-if="confirmPage && editDeliveryRequest" flat>
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_delivery_confirm }}
      </v-card-title>
      <v-card-text class="confirm-display-text">
        <!-- ２件分配達となる場合のメッセージ -->
        <v-row v-if="isDispDeliMessage(isDoubleDeli)" class="time_chk_card">
          <v-col cols="10" class="text-subtitle-1 text-red">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="doubleDeliCheckLabel"></span>
          </v-col>
        </v-row>
        <!-- チャーター便となる場合のメッセージ -->
        <v-row v-if="isDispDeliMessage(isCharterDeli)" class="time_chk_card">
          <v-col cols="10" class="text-subtitle-1 text-red">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="charterDeliChkLabel"></span>
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 受付番号 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
          >{{ wordList.lbl_reception_no }}
            <ImportantChip></ImportantChip></v-row
          ></v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editDeliveryRequest.reception_no }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 配達先住所 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination_address }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            <!-- 個人情報閲覧可 または 配送住所1表示フラグが1の場合、住所1を表示 -->
            <template
              v-if="
                isPersonalInfoPossible === true ||
                is_delivery_address1_display === 1
              "
            >
              <!-- 個人情報非表示時は郵便番号を分割表示しない -->
              <template v-if="isPersonalInfoPossible === true">
                {{ editDeliveryRequest?.delivery_zip_code ? "〒" : "" }}
                {{ editDeliveryRequest?.delivery_zip_code?.substring(0, 3) }}
                {{ editDeliveryRequest?.delivery_zip_code ? "-" : "" }}
                {{ editDeliveryRequest?.delivery_zip_code?.substring(3) }}
              </template>
              {{ editDeliveryRequest?.delivery_address1 }}
            </template>
            <template v-else>
              {{ editDeliveryRequest?.delivery_address1 }}
            </template>
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!--配達先住所(番地) -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination_address_detail }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editDeliveryRequest?.delivery_address2 }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 建物名 部屋番号 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_room_num
            }}</v-row></v-col
          >
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editDeliveryRequest.delivery_address3 }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 配達希望エリア -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_area }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ deliveryAreaName }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 配達希望時間選択 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
            {{ wordList.lbl_delivery_time_select }}
            <ImportantChip></ImportantChip> </v-row
          ></v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ displayDeliveryTime }}
          </v-col>
        </v-row>
        <!-- 配達希望時間 -->
        <v-row v-if="editDeliveryRequest?.delivery_id === 0" dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_delivery_time }}
            </v-row>
          </v-col>
          <v-col cols="8" class="text-body-1">
            {{ irregularDeliveryStartTime }} ～
            {{ irregularDeliveryEndTime }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- お名前(漢字) -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
            {{ wordList.lbl_name_kanji }}
            <ImportantChip></ImportantChip>
          </v-row>
          </v-col>
          <v-col
              v-if="isPersonalInfoPossible"
              cols="12"
              sm="8"
              md="8"
              lg="8"
              class="text-body-1"
          >{{ editDeliveryRequest.delivery_name1
            }}{{ editDeliveryRequest.delivery_name2 }}</v-col
          >
          <v-col
              v-if="!isPersonalInfoPossible"
              cols="12"
              sm="8"
              md="8"
              lg="8"
              class="color_black"
          >
            {{ personalInfoImpossible }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- お名前(かな) -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_name_kana
            }}</v-row></v-col
          >
          <v-col
              v-if="isPersonalInfoPossible"
              cols="12"
              sm="8"
              md="8"
              lg="8"
              class="text-body-1"
          >{{ editDeliveryRequest.delivery_name_kana1
            }}{{ editDeliveryRequest.delivery_name_kana2 }}</v-col
          >
          <v-col
              v-if="!isPersonalInfoPossible"
              cols="12"
              sm="8"
              md="8"
              lg="8"
              class="color_black"
          >
            {{ personalInfoImpossible }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 電話番号 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
            {{ wordList.lbl_tel }}
            <ImportantChip></ImportantChip> </v-row
          ></v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">{{
              editDeliveryRequest.delivery_phone
            }}</v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 決済方法 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
            {{ wordList.lbl_pay_method }}
            <ImportantChip></ImportantChip> </v-row
          ></v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">{{
              editDeliveryRequest.payment_method
            }}</v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 支払金額 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center"
                v-if="paymentRequiredFlg"
                dense
                  class="form-label-row mr-3 justify-sm-end"
            >
              {{ wordList.lbl_pay_money }}
              <ImportantChip></ImportantChip>
            </v-row>
            <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_pay_money }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1"
          >{{ dummy_payment_amount }}
            {{
              dummy_payment_amount !== null && dummy_payment_amount !== ""
                  ? wordList.lbl_yen
                  : ""
            }}</v-col
          >
        </v-row>
        <v-row v-if="setRegisterNoDisplay()" dense class="mb-3">
          <!-- レジNo -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_cash_register_no
            }}</v-row></v-col
          >
          <v-col cols="12" sm="8" md="8" lg="8">{{
              editDeliveryRequest.register_no
            }}</v-col>
        </v-row>
        <v-row v-if="setReceiptNoDisplay()" dense class="mb-3">
          <!-- レシートNo -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_receipt_no
            }}</v-row></v-col
          >
          <v-col cols="12" sm="8" md="8" lg="8">{{
              editDeliveryRequest.receipt_no
            }}</v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 個口数 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_unit_number }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1"
          >{{ editDeliveryRequest.unit }}{{ wordList.lbl_unit }}</v-col
          >
        </v-row>
        <v-row v-if="house_card_display == 1" dense class="mb-3">
          <!-- ハウスカード番号 -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center"
                v-if="house_card_required == 1"
                dense
                  class="form-label-row mr-3 justify-sm-end"
            >
              {{ wordList.lbl_house_card }}
              <ImportantChip></ImportantChip>
            </v-row>
            <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_house_card }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editDeliveryRequest.house_card }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 会員備考 -->
          <v-col cols="4" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_memo_member
            }}</v-row></v-col
          >
          <v-col cols="8" sm="8" md="8" lg="8" class="text-body-1">{{
              editDeliveryRequest.member_notes
            }}</v-col>
          <v-col offset="4" cols="8" class="text-body-1 text-caption">
            {{ messageMemberNotes }}
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 配達備考 -->
          <v-col cols="4" sm="4" md="4" lg="4" class="font-weight-black"
          ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_memo_delivery
            }}</v-row></v-col
          >
          <v-col cols="8" sm="8" md="8" lg="8" class="text-body-1">{{
              editDeliveryRequest.delivery_notes
            }}</v-col>
          <v-col offset="4" cols="8" class="text-body-1 text-caption">
            {{ messageDeliveryNotes }}
          </v-col>
        </v-row>
      </v-card-text>
      <!-- 編集処理時のボタン { -->
      <v-card-actions v-if="processFlag < 2" class="justify-center flex-wrap">
        <v-btn
            v-if="
            isDisabled ||
            house_card_display == 0 ||
            (house_card_display == 1 && !house_card_change)
          "
            variant="flat"
            color="primary"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmUpdateOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delivery_regist }}</v-btn
        >
        <v-btn
            v-if="!isDisabled"
            variant="flat"
            color="primary"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmUpdateAndMember"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delivery_member_regist }}</v-btn
        >
      </v-card-actions>
      <v-card-actions v-if="processFlag < 2" class="justify-center">
        <v-btn
            variant="flat"
            color="return"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}</v-btn
        >
      </v-card-actions>
      <!-- } 編集処理時のボタン -->
      <!-- キャンセル処理時のボタン { -->

      <v-card-actions v-if="processFlag == 2" class="justify-center flex-wrap">
        <v-btn
            variant="flat"
            color="return"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}</v-btn
        >
        <v-btn
            variant="flat"
            color="primary"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmDeleteOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delete_complete }}
        </v-btn>
      </v-card-actions>
      <!-- } キャンセル処理時のボタン -->
      <!-- 閲覧処理時のボタン { -->

      <v-card-actions v-if="processFlag == 3" class="justify-center flex-wrap">
        <v-btn
            variant="flat"
            color="return"
            class="btn_width_1 my-2 mx-2"
            @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}</v-btn
        >
      </v-card-actions>
      <!-- } 閲覧処理時のボタン -->
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 配達依頼更新確認 -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <!-- キャンセル確認ダイアログ {-->
    <v-dialog
        v-model="confirmDeleteDialog"
        content-class="dialog_width_1"
        :lock-scroll="false"
        scrollable
    >
      <v-data-iterator
          :items="filteredSelectListCheckbox()"
          item-key="name"
          hide-default-footer
          :items-per-page="-1"
      >
                <template #default="{ items }">
                  <v-card class="rounded-t rounded-b-0">
                    <v-card-title class="bg-red mb-5" style="color: white"
                    >一括キャンセル内容確認</v-card-title
                    >
                    <v-card-text class="font-weight-black"
                    >{{
                        filteredSelectListCheckbox().length
                      }}
                      件の配達依頼をキャンセルします。</v-card-text
                    >
                    <v-card-text style="max-height: 60vh; overflow-y: auto;">
                            <v-card
                                v-for="item in items"
                                :key="item.raw.name"
                                flat
                                border
                                class="mb-5"
                            >
                              <v-card-title>
                                <h4>{{ item.raw.receptionNo }} : {{ item.raw.name }}</h4>
                              </v-card-title>
                              <v-divider class="mx-4"></v-divider>
                              <v-list density="compact">
                                <v-list-item>
                                  <v-row dense>
                                    <v-col
                                        cols="5"
                                        sm="3"
                                        md="3"
                                        lg="3"
                                        class="font-weight-black"
                                    >
                                      <v-row dense class="py-2 justify-end">受付番号:</v-row>
                                    </v-col>
                                    <v-col cols="7" class="d-flex align-center"
                                    >{{ item.raw.receptionNo }}
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row dense>
                                    <v-col
                                        cols="5"
                                        sm="3"
                                        md="3"
                                        lg="3"
                                        class="font-weight-black"
                                    >
                                      <v-row dense class="py-2 justify-end">お名前:</v-row>
                                    </v-col>
                                    <v-col cols="7" class="d-flex align-center"
                                    >{{ item.raw.name }}
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row dense>
                                    <v-col
                                        cols="5"
                                        sm="3"
                                        md="3"
                                        lg="3"
                                        class="font-weight-black"
                                    >
                                      <v-row dense class="py-2 justify-end">便名:</v-row>
                                    </v-col>
                                    <v-col cols="7" class="d-flex align-center"
                                    >{{ item.raw.deliveryIdName }}
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                  <!-- 配達予定日データをDSSと連携されるまで非表示にする
                    <v-list-item>
                      <v-row dense>
                        <v-col
                          cols="5"
                          sm="3"
                          md="3"
                          lg="3"
                          class="font-weight-black"
                        >
                          <v-row dense class="py-2 justify-end"
                            >配達予定時刻:</v-row
                          >
                        </v-col>
                        <v-col cols="7" class="d-flex align-center"
                          >{{ item.deliveryEstimatedTime }}
                        </v-col>
                      </v-row>
                    </v-list-item>
                  -->
                          <v-list-item>
                            <v-row dense>
                              <v-col
                                  cols="5"
                                  sm="3"
                                  md="3"
                                  lg="3"
                                  class="font-weight-black"
                              >
                                <v-row dense class="py-2 justify-end"
                                >ステータス:</v-row
                                >
                              </v-col>
                              <v-col cols="7" class="d-flex align-center"
                              >{{ item.raw.status }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-card-text>
                    <!-- ボタンをカード内に配置して上下中央に表示（モバイル時はflex-wrapで折り返し） -->
                    <v-card-actions class="justify-center pb-8 flex-wrap">
                      <!-- 戻るボタン -->
                      <v-btn
                          variant="flat"
                          color="return"
                          class="px-16 mx-2 my-2"
                          width="168px"
                          @click="confirmDeleteDialog = false"
                      >
                        <v-icon>mdi-arrow-left</v-icon>
                        {{ wordList.btn_return }}</v-btn
                      >
                      <v-btn
                          variant="outlined"
                          class="bg-red-darken-1 mx-2 my-2"
                          color="white"
                          width="168px"
                          @click="onClickCheckDeleteComplete"
                      >{{ wordList.btn_delete_all }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </template>
              </v-data-iterator>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- } キャンセル確認ダイアログ -->
    <!-- 荷札印刷ダイアログ {-->
        <TagLabelPrintDialog
            ref="tagLabelPrintDialogRef"
            v-model:confirm-tag-print-dialog="confirmTagPrintDialog"
            :print-shipping-data="filteredSelectListCheckbox()"
            :overlay="overlay"
        />
    <!-- } 荷札印刷ダイアログ -->
    <!-- 伝票印刷ダイアログ {-->
        <SlipLabelPrintDialog
            ref="slipLabelPrintDialogRef"
            v-model:confirm-slip-print-dialog="confirmSlipPrintDialog"
            :print-shipping-data="slipPrintShippingData"
            :overlay="overlay"
        />
    <!-- } 伝票印刷ダイアログ -->
    <!-- 住所選択共通ダイアログ -->
    <AddressSelectorDialog
      :address-dialog="addressDialog"
      :area-dialog="areaDialog && !addressResolveLoading"
      :toggle-mode="btnNonMemberToggle"
      :zip-code="zip_code"
      :pref="prefSelectValue"
      :pref-list-items="prefListItems ?? []"
      :selected-address="selectedAddressLabel"
      :original-city="originalCityAddress"
      :city-block-list="cityBlockList ?? null"
      :section-block-list="sectionBlockList ?? null"
      :block-list="addressDialogBlockList"
      :click-disabled="addressResolveLoading || clickMode"
      :area-not-select-message="addressAreaNotSelectMessage"
      :errors="addressDialogErrors"
      :word-list="wordList"
      @update:address-dialog="onAddressDialogUpdate"
      @update:area-dialog="onAreaDialogUpdate"
      @update:zip-code="onZipCodeUpdate"
      @update:pref="onPrefUpdate"
      @toggle-zip="onClickToggleZip"
      @toggle-pref="onClickTogglePref"
      @zip-input="onZipCodeInput"
      @pref-input="onPrefSelectInput"
      @search="onClickAddressChangeBtn"
      @close-address="onClickAddressDialogReturn"
      @area-return="onClickAreaDialogReturn"
      @select-city="onClickCityBlockLink"
      @select-section="onClickSectionBlockLink"
      @select-block="onClickAddressBlockLink"
    />
    <!-- ダウンロード中 ダイアログ { -->
    <v-dialog v-model="downloadingDialog" persistent width="40%">
      <v-card>
        <v-card-title>配達依頼ダウンロード</v-card-title>
        <v-card-text>
          <v-container style="height: 200px">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                ダウンロード中...
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                    color="deep-purple-accent-4"
                    indeterminate
                    rounded
                    height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- } ダウンロード中 ダイアログ -->
    <!-- 一覧設定ダイアログ { -->
    <v-dialog
        v-model="displayListSettingDialog"
        persistent
        content-class="dialog_width_2"
        height="100%"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center pb-0">
          <div>一覧設定</div>
          <v-btn
            variant="text"
            icon="mdi-close"
            @click="displayListSettingDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container class="pt-2">
            <draggable
                v-model="tableHeadersSetting"
                item-key="id"
            >
              <template #item="{ element: tableHeader }">
                <v-row
                    :key="tableHeader.id"
                    class="mt-0 mb-0 pt-0 pb-0"
                    :class="{ br_b_1: isXs }"
                >
                  <v-col
                      cols="12"
                      class="my-2 pt-0 pb-0 d-flex justify-space-between align-center"
                      :class="{ 'px-0': isXs }"
                  >
                    <div :class="{ caption: isXs }">
                      <v-icon>mdi-drag</v-icon>
                      {{ tableHeader.settingText }}
                    </div>
                    <div
                        class="d-flex pt-0"
                        :class="{ 'mt-1': isXs }"
                    >
                      <div class="d-flex align-center">
                        <v-switch
                            v-model="tableHeader.display"
                            color="primary"
                            class="mt-0"
                            hide-details
                        ></v-switch>
                        <div class="setting_line"></div>
                      </div>
                      <v-radio-group
                          v-model="tableHeader.order"
                          inline
                          class="mt-0 flex-shrink-0"
                          hide-details
                      >
                        <v-radio
                            true-icon="mdi-arrow-up-drop-circle"
                            false-icon="mdi-arrow-up-drop-circle-outline"
                            value="asc"
                            :disabled="tableHeader.orderDisabled"
                            class="mr-1"
                            false="color_primary"
                        ></v-radio>
                        <v-radio
                            true-icon="mdi-arrow-down-drop-circle"
                            false-icon="mdi-arrow-down-drop-circle-outline"
                            value="desc"
                            :disabled="tableHeader.orderDisabled"
                            class="mr-0"
                            false="color_primary"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </draggable>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-5 pb-7">
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingCancel"
          >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingReset"
          >リセット</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="flat"
            color="primary"
            @click="onClickListSettingOk"
          >設定</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- } 一覧設定ダイアログ -->
    <!-- スマホ検索ダイアログ { -->
    <v-dialog
        v-model="displayListSearchDialog"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
    >
      <Form v-slot="{ meta }">
        <v-card flat>
          <v-card-title class="px-0 py-0">
            <v-toolbar color="primary" class="text-white">
              <v-btn
                  icon
                  class="text-white"
                  @click="displayListSearchDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>絞り込み検索</v-toolbar-title>
              <v-spacer></v-spacer> </v-toolbar
            ></v-card-title>
          <v-card-text
              class="py-0 overflow-auto"
              style="height: calc(100vh - 133px)"
          >
            <v-row>
              <!-- お名前(漢字・かな) -->
              <v-col cols="12" sm="6" md="4" class="mt-10 py-0">
                <Field
                    v-slot="{ errors }"
                    v-model="searchConditionName"
                    name="nameKanjiKana"
                              :label="wordList.lbl_name_kanji_kana"
                    rules="max:100"
                >
                  <v-text-field
                      v-model="searchConditionName"
                      :label="wordList.lbl_name_kanji_kana"
                      bg-color="#fff"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
              <!-- 電話番号 -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <Field
                    v-slot="{ errors }"
                    v-model="searchConditionPhone"
                    name="tel"
                              :label="wordList.lbl_tel"
                    rules="max:100"
                >
                  <v-text-field
                      v-model="searchConditionPhone"
                      :label="wordList.lbl_tel"
                      bg-color="#fff"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
              <!-- 郵便番号 -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <Field
                    v-slot="{ errors }"
                    v-model="searchConditionZipCode"
                    name="zipcode"
                              :label="wordList.lbl_zipcode"
                    rules="max:100"
                >
                  <v-text-field
                      v-model="searchConditionZipCode"
                      :label="wordList.lbl_zipcode"
                      bg-color="#fff"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors"
                  ></v-text-field>
                </Field>
              </v-col>
              <!-- 配達エリア -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <Field
                    v-slot="{ errors }"
                    v-model="areaSelectValues"
                    name="deliveryAreaName"
                              :label="wordList.lbl_delivery_area_name"
                    rules="max:100"
                >
                  <v-autocomplete
                      v-model="areaSelectValues"
                      density="compact"
                      :items="areaListItems ?? []"
                      item-title="area_name"
                      item-value="area_code"
                      :label="wordList.lbl_delivery_area_name"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      return-object
                      variant="outlined"
                      bg-color="#fff"
                  ></v-autocomplete>
                </Field>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-row>
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                        v-slot="{ errors }"
                        v-model="searchConditionReceptionDateFromDisplay"
                        name="recriptDateFrom"
                        :label="wordList.lbl_recript_date_from"
                        rules="max:100"
                    >
                      <v-menu
                          v-model="ReceptionDateFrom"
                          :close-on-content-click="false"
                          location="bottom start"
                          :offset="[0, -40]"
                          transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                              v-bind="props"
                              v-model="searchConditionReceptionDateFromDisplay"
                              :label="wordList.lbl_recript_date_from"
                              prepend-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              density="compact"
                              clearable
                              :error-messages="errors"
                              bg-color="#fff"
                              hide-details
                              @click:clear="clearReceptionDateFrom"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                            locale="ja"
                            :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                              v-datepicker-scroll
                              v-model="searchConditionReceptionDateFrom"
                              hide-header
                              show-adjacent-months
                              view-mode="month"
                              @update:model-value="onReceptionDateFromSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center"
                  ><span>〜</span></v-col
                  >
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                        v-slot="{ errors }"
                        v-model="searchConditionReceptionDateToDisplay"
                        name="recriptDateTo"
                        :label="wordList.lbl_recript_date_to"
                        rules="max:100"
                    >
                      <v-menu
                          v-model="ReceptionDateTo"
                          :close-on-content-click="false"
                          location="bottom start"
                          :offset="[0, -40]"
                          transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                              v-bind="props"
                              v-model="searchConditionReceptionDateToDisplay"
                              :label="wordList.lbl_recript_date_to"
                              prepend-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              density="compact"
                              clearable
                              :error-messages="errors"
                              bg-color="#fff"
                              @click:clear="clearReceptionDateTo"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                            locale="ja"
                            :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                              v-datepicker-scroll
                              v-model="searchConditionReceptionDateTo"
                              hide-header
                              show-adjacent-months
                              view-mode="month"
                              @update:model-value="onReceptionDateToSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                        v-slot="{ errors }"
                        v-model="searchConditionDeliveryDateFromDisplay"
                        name="deliveryDateFrom"
                        :label="wordList.lbl_delivery_date_from"
                        rules="max:100"
                    >
                      <v-menu
                          v-model="DeliveryDateFrom"
                          :close-on-content-click="false"
                          location="bottom start"
                          :offset="[0, -40]"
                          transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                              v-bind="props"
                              v-model="searchConditionDeliveryDateFromDisplay"
                              :label="wordList.lbl_delivery_date_from"
                              prepend-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              density="compact"
                              clearable
                              :error-messages="errors"
                              bg-color="#fff"
                              hide-details
                              @click:clear="clearDeliveryDateFrom"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                            locale="ja"
                            :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                              v-datepicker-scroll
                              v-model="searchConditionDeliveryDateFrom"
                              hide-header
                              show-adjacent-months
                              view-mode="month"
                              @update:model-value="onDeliveryDateFromSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center"
                  ><span>〜</span></v-col
                  >
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                        v-slot="{ errors }"
                        v-model="searchConditionDeliveryDateToDisplay"
                        name="deliveryDateTo"
                        :label="wordList.lbl_delivery_date_to"
                        rules="max:100"
                    >
                      <v-menu
                          v-model="DeliveryDateTo"
                          :close-on-content-click="false"
                          location="bottom start"
                          :offset="[0, -40]"
                          transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                              v-bind="props"
                              v-model="searchConditionDeliveryDateToDisplay"
                              :label="wordList.lbl_delivery_date_to"
                              prepend-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              density="compact"
                              clearable
                              :error-messages="errors"
                              bg-color="#fff"
                              @click:clear="clearDeliveryDateTo"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                            locale="ja"
                            :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                              v-datepicker-scroll
                              v-model="searchConditionDeliveryDateTo"
                              hide-header
                              show-adjacent-months
                              view-mode="month"
                              @update:model-value="onDeliveryDateToSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-9">
                <v-card flat>
                  <v-card-title class="px-0 pt-0 pb-2 text-subtitle-2">
                    {{ wordList.lbl_status }}
                  </v-card-title>
                  <v-card-text class="px-0 py-0">
                    <v-row>
                      <div
                          v-for="item in deliveryStatusName"
                          :key="item.id"
                          class="pr-3 pl-2 d-flex"
                      >
                        <v-checkbox
                            v-model="statusSelectedItem"
                            :value="item.id"
                            :label="item.name"
                            hide-details
                        ></v-checkbox>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                variant="flat"
                color="primary"
                class="px-16 my-3"
                :disabled="!meta.valid"
                @click="onClickSearch"
            ><v-icon>mdi-magnify</v-icon>{{ wordList.lbl_search }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </Form>
    </v-dialog>
    <!-- } スマホ検索ダイアログ -->
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch, nextTick } from "vue";
import { useDisplay } from "vuetify";
import { ja as vuetifyJa } from "vuetify/locale";

// ------ Vee-Validate ------
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max, min, numeric, regex, length } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import {
  useDeliveryRequestHeaders,
  useDeliveryRequestTable,
  useDeliveryRequestTableSettings,
} from "./composables/useDeliveryRequestTable";
import {
  useDeliveryRequestFilterOptions,
  useDeliveryRequestFilterState,
} from "./composables/useDeliveryRequestFilterOptions";
import { useDeliveryRequestUiState } from "./composables/useDeliveryRequestUiState";
import {
  useDeliveryRequestInit,
  useDeliveryRequestInitContext,
  useDeliveryRequestInitState,
} from "./composables/useDeliveryRequestInit";
import {
  useDeliveryRequestActions,
  useDeliveryRequestActionsState,
} from "./composables/useDeliveryRequestActions";
import { useDeliveryRequestDownload } from "./composables/useDeliveryRequestDownload";
import {
  useDeliveryRequestAddress,
  useDeliveryRequestAddressState,
} from "./composables/useDeliveryRequestAddress";
import {
  useDeliveryRequestDeliveryTime,
  useDeliveryRequestDeliveryTimeState,
} from "./composables/useDeliveryRequestDeliveryTime";
import {
  useDeliveryRequestEditForm,
  useDeliveryRequestEditState,
} from "./composables/useDeliveryRequestEditForm";
import { useDeliveryRequestSearchForm } from "./composables/useDeliveryRequestSearchForm";
import { DELIVERY_REQUEST_LIST_FILE_NAME } from "./constants";

// ------ Local Components ------
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import SlipLabelPrintDialog from "@/components/SlipLabelPrintDialog.vue";
import TagLabelPrintDialog from "@/components/TagLabelPrintDialog.vue";
import AddressSelectorDialog from "@/components/address-selector/AddressSelectorDialog.vue";
import type {
  AddressBlockItem as SharedAddressBlockItem,
  AddressSelectionErrors,
} from "@/components/address-selector/types";

// ------ Utilities / Common ------
import draggable from "vuedraggable";
import { DeliveryRequest } from "@/common/constant";
import shopStore from "@/store/shopStore";
import { localStorageGetGroup } from "@/common/localStorageUtil";

// ============================
// Vee-Validate rules / locale
// ============================
defineRule("required", required);
defineRule("max", max);
defineRule("min", min);
defineRule("numeric", numeric);
defineRule("regex", regex);
defineRule("length", length);
configure({
  generateMessage: localize({
    ja,
  }),
});
localize("ja");

// ============================
// state
// ============================
// Vuetify breakpoint
const { xs } = useDisplay();
const isXs = computed(() => xs.value);

// モバイル時はヘッダーから「詳細」「キャンセル」を除外し、アクション用の列を追加する
const mobileFilteredTableHeaders = (): TableHeader[] => {
  const headers = filteredTableHeaders();
  if (isXs.value) {
    const filtered = headers.filter((h) => h.key !== 'detail' && h.key !== 'cancel');
    // モバイルカードの末尾にボタン表示用の行を追加
    filtered.push({ id: 99, display: true, title: '', settingText: '', align: 'center', sortable: false, orderDisabled: true, order: '', orderKey: '', key: 'mobileActions' });
    return filtered;
  }
  return headers;
};

// コンポーネント名
const thisFileName = DELIVERY_REQUEST_LIST_FILE_NAME;

// -------------------------------
// 一覧ヘッダー定義
// -------------------------------
const {
  defaultTableHeaders,
  tableHeaders,
  initializeTableHeaders,
  filteredTableHeaders,
} = useDeliveryRequestHeaders();

// -------------------------------
// 画面UI状態
// -------------------------------
const {
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  panel,
  processFlag,
  confirmDeleteDialog,
  addressDialog,
  areaDialog,
  overlay,
  confirmTagPrintDialog,
  confirmSlipPrintDialog,
  downloadingDialog,
  displayListSettingDialog,
  displayListSearchDialog,
  onClickListSearch,
  openListPage,
  openConfirmDeletePage,
  openViewPage,
} = useDeliveryRequestUiState();

// -------------------------------
// 一覧設定ダイアログ
// -------------------------------
const {
  tableHeadersSetting,
  onClickListSetting,
  onClickListSettingCancel,
  onClickListSettingReset,
  onClickListSettingOk,
} = useDeliveryRequestTableSettings({
  pageKey: thisFileName,
  defaultTableHeaders,
  tableHeaders,
  displayListSettingDialog,
});

// -------------------------------
// 共有 State
// -------------------------------
const {
  chainListItems,
  bufChainListItems,
  chainSelectValues,
  bufChainSelectValues,
  chainAllCheckFlag,
  searchConditionChainCode,
  searchConditionShopCode,
  areaListItems,
  areaSelectValues,
  shopSelectValues,
  shopAllCheckFlag,
  shopListItems,
  bufShopListItems,
} = useDeliveryRequestFilterState();

// -------------------------------
// 住所 State
// -------------------------------
const {
  btnNonMemberToggle,
  errorZipCode,
  userErrorMessage,
  errorPrefSelect,
  zipCodeFromPref,
  prefListItems,
  pref_name,
  pref_name_befor,
  listDeliveryArea,
  deliveryAreaName,
  blockList,
  unassignedBlockList,
  zipAddressList,
  sectionBlockList,
  addressBlockList,
  zip_code,
  prefSelectValue,
  cityBlockList,
  originalAddress,
  originalCityAddress,
  originalSectionAddress,
  originalBlockName,
  addressResolveLoading,
  clickMode,
} = useDeliveryRequestAddressState();

// -------------------------------
// 編集 State
// -------------------------------
const {
  editDeliveryRequest,
  paymentMethodItems,
  dummy_payment_amount,
} = useDeliveryRequestEditState();

// -------------------------------
// 便・時間帯 State
// -------------------------------
const {
  acceptableEndTime,
  deliveryId_0_Flg,
  overDeliveryEndTime,
  doubleDeliOriconCount,
  isDoubleDeli,
  pre_double_deli_oricon_flg,
  charterDeliOriconCount,
  isCharterDeli,
  pre_charter_deli_oricon_flg,
  delivery_type,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  displayDeliveryTime,
  targetShopCode,
} = useDeliveryRequestDeliveryTimeState();

// -------------------------------
// 一覧選択 State
// -------------------------------
const {
  selectListCheckbox,
  filteredSelectListCheckbox,
} = useDeliveryRequestActionsState();

// -------------------------------
// 初期化・権限 State
// -------------------------------
const {
  unitItems,
  paymentRequiredFlg,
  paymentList,
  isDisabled,
  isPersonalInfoPossible,
  personalInfoImpossible,
  house_card_display,
  house_card_validation,
  house_card_required,
  house_card_change,
  house_card_befor,
  register_no_max_length,
  register_no_validation,
  receipt_no_max_length,
  receipt_no_validation,
  memberNotesBefore,
  deliveryNotesBefore,
  messageMemberNotes,
  messageDeliveryNotes,
  authType,
  shipping_label_print_flg,
  delivery_order_print_flg,
  is_delivery_address1_display,
  is_hide_delivery_time_on_spot,
} = useDeliveryRequestInitState();

// -------------------------------
// マウント時処理
// -------------------------------
const { wordList, chainViewFlag } = useDeliveryRequestInitContext();
const deliveryStatusName: { id: string; name: string }[] = DeliveryRequest.status;

// -------------------------------
// 検索フォーム State
// -------------------------------
const {
  formatDateForDisplay,
  searchConditionReceptionNo,
  searchConditionMemberId,
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionRegisterNo,
  searchConditionReceiptNo,
  ReceptionDateFrom,
  ReceptionDateTo,
  DeliveryDateFrom,
  DeliveryDateTo,
  searchConditionReceptionDateFrom,
  searchConditionReceptionDateTo,
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  searchConditionReceptionDateFromDisplay,
  searchConditionReceptionDateToDisplay,
  searchConditionDeliveryDateFromDisplay,
  searchConditionDeliveryDateToDisplay,
  onReceptionDateFromSelected,
  onReceptionDateToSelected,
  onDeliveryDateFromSelected,
  onDeliveryDateToSelected,
  clearReceptionDateFrom,
  clearReceptionDateTo,
  clearDeliveryDateFrom,
  clearDeliveryDateTo,
  statusSelectedItem,
} = useDeliveryRequestSearchForm();

// -------------------------------
// 一覧取得・ページング
// -------------------------------
const {
  listLoading,
  listOptions,
  listDataArray,
  listDataTotalCount,
  displayPagingRangeText,
  searchShopSelectValues,
  pageCount,
  onClickSearch,
  searchQuery,
} = useDeliveryRequestTable({
  formatDateForDisplay,
  searchConditionReceptionNo,
  searchConditionMemberId,
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionRegisterNo,
  searchConditionReceiptNo,
  searchConditionReceptionDateFrom,
  searchConditionReceptionDateTo,
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  areaSelectValues,
  statusSelectedItem,
  searchConditionChainCode,
  searchConditionShopCode,
  authType,
  chainViewFlag,
  isDeliveryAddressDisplay: is_delivery_address1_display,
  isPersonalInfoPossible,
  errdialog,
  errMessage,
  editPage,
  displayListSearchDialog,
});
const listPageForReturn = ref(listOptions.value.page);
// 一覧から編集・詳細画面へ遷移する前に現在のページを記録する
const captureListPageForReturn = (): void => {
  listPageForReturn.value = listOptions.value.page;
};
// 編集・詳細キャンセル時に元ページへ戻して一覧再取得する共通処理
const returnToListPage = async (): Promise<void> => {
  if (listPageForReturn.value < 1) {
    return;
  }

  await nextTick();
  listOptions.value.page = listPageForReturn.value;
  await searchQuery();
};

// -------------------------------
// フィルタ連動
// -------------------------------
const {
  shopViewFlag,
  shopDisabledFlag,
  areaDisabledFlag,
  shopListInput,
  onchangeChainAllCheck,
  onChangeChain,
  onchangeShopAllCheck,
  onChangeShop,
} = useDeliveryRequestFilterOptions({
  chainListItems,
  bufChainListItems,
  chainSelectValues,
  bufChainSelectValues,
  chainAllCheckFlag,
  searchConditionChainCode,
  searchConditionShopCode,
  areaListItems,
  areaSelectValues,
  shopSelectValues,
  shopAllCheckFlag,
  shopListItems,
  bufShopListItems,
  listDataArray,
  searchShopSelectValues,
  listOptions,
  listDataTotalCount,
  chainViewFlag,
  authType,
  errdialog,
  errMessage,
});

// -------------------------------
// 初期化ロジック
// -------------------------------
const {
  runInitialLoad,
  setRegisterNoDisplay,
  setReceiptNoDisplay,
} = useDeliveryRequestInit({
  initializeTableHeaders,
  pageKey: thisFileName,
  chainViewFlag,
  authType,
  isPersonalInfoPossible,
  personalInfoImpossible,
  wordList,
  bufChainListItems,
  chainListItems,
  chainAllCheckFlag,
  chainSelectValues,
  searchConditionChainCode,
  shopListInput,
  bufShopListItems,
  shopAllCheckFlag,
  shopDisabledFlag,
  shopSelectValues,
  searchConditionShopCode,
  shopListItems,
  areaDisabledFlag,
  shipping_label_print_flg,
  delivery_order_print_flg,
  house_card_display,
  house_card_validation,
  house_card_required,
  house_card_change,
  house_card_befor,
  register_no_max_length,
  receipt_no_max_length,
  register_no_validation,
  receipt_no_validation,
  memberNotesBefore,
  deliveryNotesBefore,
  messageMemberNotes,
  messageDeliveryNotes,
  is_delivery_address1_display,
  is_hide_delivery_time_on_spot,
  areaListItems,
  unitItems,
  originalAddress,
  prefSelectValue,
  cityBlockList,
  errdialog,
  errMessage,
});

onMounted(async (): Promise<void> => {
  await runInitialLoad();
});

// -------------------------------
// 便・時間帯ロジック
// -------------------------------
const {
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  befor_data,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  deliveryStartTime,
  deliveryEndTime,
  deliverySelectDayBox,
  deliverySelectBox,
  formatDate,
  isDispDeliMessage,
  doubleDeliCheckLabel,
  charterDeliChkLabel,
  onClickListDeliveryArea,
  onDeliveryAvailabilityClick,
  onChangeDeliveryStartHour,
  onChangeDeliveryStartMinit,
  initializeEditDeliveryTime,
  setDeliveryStartTime,
  setDeliveryEndTime,
  getDeliveryTimeList,
} = useDeliveryRequestDeliveryTime({
  listDeliveryArea,
  targetShopCode,
  editDeliveryRequest,
  errdialog,
  errMessage,
  deliveryAreaName,
  acceptableEndTime,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  sectionBlockList,
  blockList,
  originalCityAddress,
  originalSectionAddress,
  zipCodeFromPref,
  displayDeliveryTime,
  deliveryId_0_Flg,
  delivery_type,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  wordList,
});

// -------------------------------
// 編集フォームロジック
// -------------------------------
const {
  editFormRef,
  validateEditForm,
  onChangePaymentMethod,
  commmaMoney,
  onFocus,
  onBlur,
  onChangeHouseCard,
  onClickUpdateCancel,
  onClickUpdate,
  onClickConfirmUpdateCancel,
  onClickConfirmUpdateOk,
  onClickConfirmUpdateAndMember,
} = useDeliveryRequestEditForm({
  editPage,
  confirmPage,
  processFlag,
  overlay,
  errdialog,
  errMessage,
  editDeliveryRequest,
  memberNotesBefore,
  deliveryNotesBefore,
  messageMemberNotes,
  messageDeliveryNotes,
  paymentRequiredFlg,
  paymentList,
  dummy_payment_amount,
  house_card_befor,
  house_card_change,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  deliveryId_0_Flg,
  pre_double_deli_oricon_flg,
  pre_charter_deli_oricon_flg,
  isDoubleDeli,
  isCharterDeli,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  acceptableEndTime,
  overDeliveryEndTime,
  isDisabled,
  wordList,
  openListPage,
  returnToListPage,
  // 2件分配達・チャーター便の閾値はshopStoreから取得する（#195 ローカルrefではなくstoreのgetterを参照）
  getDoubleDeliOriconCount: () => shopStore.getDoubleDeliOriconCount,
  getCharterDeliOriconCount: () => shopStore.getCharterDeliOriconCount,
});

// -------------------------------
// 住所ダイアログロジック
// -------------------------------
const {
  areaClear,
  getAreaList,
  onClickAddressUpdate,
  onClickAddressDialogReturn,
  onClickAreaDialogReturn,
  onClickToggleZip,
  onClickTogglePref,
  onZipCodeInput,
  onPrefSelectInput,
  onClickAddressChangeBtn,
  onClickCityBlockLink,
  onClickSectionBlockLink,
  onClickAddressBlockLink,
} = useDeliveryRequestAddress({
  btnNonMemberToggle,
  errorZipCode,
  userErrorMessage,
  errorPrefSelect,
  zipCodeFromPref,
  zip_code,
  prefSelectValue,
  pref_name,
  pref_name_befor,
  prefListItems,
  originalAddress,
  originalCityAddress,
  originalSectionAddress,
  originalBlockName,
  addressResolveLoading,
  clickMode,
  cityBlockList,
  sectionBlockList,
  blockList,
  unassignedBlockList,
  addressBlockList,
  zipAddressList,
  addressDialog,
  areaDialog,
  errdialog,
  errMessage,
  editDeliveryRequest,
  listDeliveryArea,
  targetShopCode,
  deliveryAreaName,
  acceptableEndTime,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  deliveryId_0_Flg,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  displayDeliveryTime,
  onClickListDeliveryArea,
  getDeliveryTimeList,
});

/** 住所選択ダイアログで表示する選択中住所。 */
const selectedAddressLabel = computed(() => {
  return `${prefSelectValue.value}${originalCityAddress.value}${originalSectionAddress.value}`;
});

/** 共通ダイアログ向けに丁目候補を正規化する。 */
const addressDialogBlockList = computed<SharedAddressBlockItem[]>(() => {
  const unassignedBlocks = unassignedBlockList?.value ?? [];
  return (blockList.value ?? []).map((value) => ({
    name: value,
    enabled: !unassignedBlocks.includes(value),
  }));
});

/** 配達対象外メッセージは対象丁目がある時のみ表示する。 */
const addressAreaNotSelectMessage = computed(() => {
  const unassignedBlocks = unassignedBlockList?.value ?? [];
  if (unassignedBlocks.length === 0) {
    return "";
  }
  const normalized = unassignedBlocks.map((value) => {
    const blockName = (value ?? "").trim();
    if (blockName) {
      return blockName;
    }
    return wordList.lbl_other_block_disp_name || "その他";
  });
  return wordList.lbl_area_not_select?.replace("{{s}}", normalized.join(", ")) || "";
});

/** 共通ダイアログ向けにエラーを集約する。 */
const addressDialogErrors = computed<AddressSelectionErrors>(() => {
  return {
    zip: errorZipCode.value,
    pref: errorPrefSelect.value,
    general: userErrorMessage.value,
  };
});

/** addressDialog の v-model 更新を反映する。 */
const onAddressDialogUpdate = (value: boolean): void => {
  addressDialog.value = value;
};

/** areaDialog の v-model 更新を反映する。 */
const onAreaDialogUpdate = (value: boolean): void => {
  areaDialog.value = value;
};

/** 郵便番号入力値の更新を反映する。 */
const onZipCodeUpdate = (value: string): void => {
  zip_code.value = value;
};

/** 都道府県入力値の更新を反映する。 */
const onPrefUpdate = (value: string): void => {
  prefSelectValue.value = value;
};

// -------------------------------
// 一覧行アクション
// -------------------------------
const {
  tagLabelPrintDialogRef,
  slipLabelPrintDialogRef,
  slipPrintShippingData,
  onClickEditOrView,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
  onClickDelete,
  onClickView,
  onClickTagPrintPreview,
  onClickSlipPrintPreview,
  onClickConfirmDeleteOk,
} = useDeliveryRequestActions({
  confirmDeleteDialog,
  confirmTagPrintDialog,
  confirmSlipPrintDialog,
  overlay,
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  selectListCheckbox,
  filteredSelectListCheckbox,
  searchQuery,
  captureListPageForReturn,
  openConfirmDeletePage,
  openViewPage,
  editDeliveryRequest,
  isPersonalInfoPossible,
  listLoading,
  listDataArray,
  errorZipCode,
  listOptions,
  targetShopCode,
  delivery_type,
  originalAddress,
  zipCodeFromPref,
  listDeliveryArea,
  getAreaList,
  onClickListDeliveryArea,
  paymentList,
  paymentMethodItems,
  onChangePaymentMethod,
  commmaMoney,
  areaClear,
  acceptableEndTime,
  deliveryId_0_Flg,
  overDeliveryEndTime,
  doubleDeliOriconCount,
  isDoubleDeli,
  charterDeliOriconCount,
  isCharterDeli,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  deliveryStartTime,
  deliveryEndTime,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  befor_data,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  initializeEditDeliveryTime,
  pre_double_deli_oricon_flg,
  pre_charter_deli_oricon_flg,
  displayDeliveryTime,
  house_card_befor,
  house_card_change,
  isDisabled,
  dummy_payment_amount,
  listDataTotalCount,
  is_delivery_address1_display,
  wordList,
  shopAddress: () => shopStore.getShopAddress,
});

// -------------------------------
// CSVダウンロード
// -------------------------------
const { onClickDownload } = useDeliveryRequestDownload({
  downloadingDialog,
  overlay,
  errdialog,
  errMessage,
  listDataTotalCount,
  formatDateForDisplay,
  searchConditionReceptionNo,
  searchConditionMemberId,
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionRegisterNo,
  searchConditionReceiptNo,
  searchConditionReceptionDateFrom,
  searchConditionReceptionDateTo,
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  areaSelectValues,
  statusSelectedItem,
  searchConditionChainCode,
  searchConditionShopCode,
  authType,
  is_delivery_address1_display,
});

const shouldEdit = (item: ListData): boolean => {
  // 本部権限（group=1）は個人情報表示不可のため、editAllowed=2（金額のみ編集可）は個人情報権限に関わらず編集可
  const isHq = localStorageGetGroup() === "1";
  return (
    (item.editAllowed === 1 && isPersonalInfoPossible.value === true) ||
    (item.editAllowed === 2 && (isPersonalInfoPossible.value === true || isHq))
  );
};

watch(
  [editDeliveryRequest, displayDeliveryTime, deliveryAreaName, dummy_payment_amount],
  () => {
    void validateEditForm(editPage.value);
  },
  { deep: true }
);

watch(
  [editPage, confirmPage],
  async ([editing, confirming]) => {
    if (editing || confirming) return;
    if (processFlag.value !== 2 && processFlag.value !== 3) return;
    // 確認系フロー終了時のみ、一覧ページを復元して再検索する
    await returnToListPage();
  }
);

</script>

<style scoped>
/* 一覧設定ダイアログ: v-radio-groupのデフォルトflex-directionを上書きして横並びにする */
:deep(.v-radio-group > .v-input__control) {
  flex-direction: row;
}
</style>
